<template>
  <div class="containerBlock">
    <h3 class="fb titleBorder">产品成本</h3>
    <div class="priceCols containerPaddingBlock" style="margin-bottom: 0;padding-bottom: 0;">
      <div :span="8" class="col-item">
        <div class="col-item-title">产品初始价格({{raw.customProPricesInfo.createDate}})</div>
        <div class="value">{{pricer.initPrice.toFixed(3) || 0.000}}<span>元/吨</span></div>
      </div>
      <div :span="8" class="col-item">
        <div class="col-item-title">最新产品价格({{raw.customProPricesInfo.newestDate}})</div>
        <div class="value">{{pricer.newestPrice.toFixed(3)   || 0.000}} <span>元/吨</span></div>
      </div>
      <div :span="8" class="col-item">
        <div class="col-item-title">差异</div>
          <div  class="value">
            <i :class="{red: raw.customProPricesInfo.diffPrice > 0,green:raw.customProPricesInfo.diffPrice<0,display:'inline'}">
                <a-icon style="font-size:24px" v-if="pricer.diffPrice!= 0" :type="priceType" /> 
                {{pricer.diffPrice === 0 ? '-' : pricer.diffPrice.toFixed(3)}}
            </i>
          <span>元/吨</span>
        </div>
      </div>
    </div>
    <div class="containerPaddingBlock">
      <a-tabs @change="tabChange" :activeKey="tabSelect" :animated="false" >
      <a-tab-pane key="0" tab="配方原料">
        <a-table
        :scroll="{ x: 0, y }" 
        :columns="rawColumns"
        :pagination="false"
        :row-key="record => record.id"
        :rowClassName="rowClassname"
        :dataSource="raw.customProRawVOList">
        <a-tooltip slot="rawName" slot-scope="text,record">
          <template slot="title">{{overseasFlag == '1' ? (record.aliasName || text) : text}}</template>
          {{overseasFlag == '1' ? (record.aliasName || text) : text}}
        </a-tooltip>
          <div slot="diffPrice" slot-scope="text,record" :class="{red:record.newestPrice > record.price,green:record.newestPrice < record.price}">
              <a-icon style="font-size:12px" v-if="record.price != record.newestPrice" :type="record.newestPrice > record.price ? 'arrow-up' : 'arrow-down'" /> 
              {{text || text === 0 ? text.toFixed(3) : text}}
          </div>
          <div
            v-for="(col) in ['price','newestPrice','percentage','uasge','minValue','maxValue','minLimitValue','maxLimitValue']" 
            slot-scope="text"
            :slot="col"
            :key="col"
          >
            <span :key="col">{{text || text === 0 ? text.toFixed(3) : text}}</span>
          </div>
        </a-table>
      </a-tab-pane>
      <a-tab-pane key="1" tab="配方营养需要量">
        <a-table
        :pagination="false"
        :dataSource="nut"
        :row-key="record => $uid()"
        :scroll="{ x: 0, y }"
          :columns="nutColumns">
          <template v-for="col in ['content','minValue','maxValue','minLimitValue','maxLimitValue']" :slot="col" slot-scope="text,record">
            <!-- <span :key="col" v-if="col === 'content'">{{text != null ? text.toFixed(record.unit ==='MJ' || record.unit === 'Kcal' ? 0 : 2) : text}}</span>
            <span :key="col" v-else>{{text != null ? text.toFixed(record.unit ==='MJ' || record.unit === 'Kcal' ? 0 : 3) : text}}</span> -->
        {{text || text === 0 ? text.toFixed(record.unit ==='MJ' || record.unit === 'Kcal' ? 0 : 2) : text}}
          </template>
          </a-table>
      </a-tab-pane>
    </a-tabs>
    </div>
  </div>
</template>

<script>
import { productMixins } from '../unitls'
import columns from './columns'

export default {
  mixins:[productMixins],
  props:['rowId'],
  data(){
    return {
      y: 500,
      overseasFlag: window.localStorage.getItem('overseasFlag'),
      raw:{
        customProPricesInfo:{}
      },
      nut:[],
      detail:{},
      tabSelect:"0",
      ...columns
    }
  },
  computed:{
    pricer(){
      const {numberText} = this
      let price = {initPrice:0,newestPrice:0,diffPrice:0}
      if(this.raw && this.raw.customProPricesInfo){
      const {initPrice,newestPrice,diffPrice} = this.raw.customProPricesInfo
        price = {initPrice:numberText(initPrice),newestPrice:numberText(newestPrice),diffPrice:numberText(diffPrice)}
      }
       return price
    },
    unitPrice(){
      const {price,lastPrice} = this.detail
      return this.sub((price || 0) - (lastPrice || 0))
    },
    priceType(){
      return this.raw.customProPricesInfo.diffPrice > 0 ? 'arrow-up' : 'arrow-down'
    }
  },
  mounted(){
    this.getDetail({productId: this.rowId})
    this.rawList({productId: this.rowId})
    this.nutList({productId: this.rowId})
    
    // let clientHeight = document.body.clientHeight || document.documentElement.clientHeight
    // this.y = clientHeight - 650
  },
  methods:{
    rowClassname(record){
      return record.isRawDelete == '1' ? 'selectGary' : ''
    },
    ok(){
      this.$emit('ok')
    },
    cancel(){
      this.$emit('cancel')
    },
    async getDetail(data){
      await this.fetchGet({
        name:'detail',
        data,
        actions:this.formulaproductDetail,
        loading:'detailLoading'
      })
    },

    tabChange(val){
      this.tabSelect = val
    },
    async rawList({...arg}){
      await this.fetchGet({
        name:'raw',
        actions:this.getCustomProRawByProductId,
        data:{
          // productId: this.id,
          size:1000,
          ...arg
        }
      })
    },
    async nutList({...arg}){
      this.fetchGet({
        actions:this.getCustomProNutritionByProductId,
        name:'nut',
        data:{
          // productId:this.id,
          size:1000,
          ...arg
        }
      })
    }
  }
}
</script>
<style lang="scss" scoped>
  .cols{
    padding:15px 20px;
    display: flex;
    align-items: center;
    
  }
  .col-item{
      width: 33.333333%;

      &-title{
        font-size: 12px;
        color:#777;
      }
    }
  .value{
    font-size:28px;
    font-weight: 700;
      display: flex;
      align-items: center;
    i{
      font-style: normal;
      display: flex;
      align-items: center;
    }
    span{
    margin-left: 5px;
    font-weight: normal;
      font-size:12px;
    }
  }
  .green{color:green}
  .red{color:red}
</style>
<style lang="scss" scoped>
.priceCols{
  display: flex;
  align-items: center;
}
  .fb{
    font-weight: bold;
  }
  ::v-deep .selectGary{
    background-color: rgba(130, 130, 130, 0.1) !important;
  }
</style>